import { render, staticRenderFns } from "./CreditClassRoomSave.vue?vue&type=template&id=101854f5&"
import script from "./CreditClassRoomSave.vue?vue&type=script&lang=js&"
export * from "./CreditClassRoomSave.vue?vue&type=script&lang=js&"
import style0 from "./CreditClassRoomSave.vue?vue&type=style&index=0&id=101854f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports